import { Box } from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect } from 'react'
import CardView from '../../component/card/card-view';
import Tab from '../../component/tab/tab.component'
import { Group } from '../../models'
import { GroupUnitData } from './group-unit-data';
import i18n from '../../i18n';
import './scss/group-unit.style.scss';
import AccountManager from './account-manage/account-manager';
import { MobxObjectsManager, useManualRemove } from '../mobx-objs/mobx-manager';
import AuthorizationManager from './authorization-manager/authorization-manager';
import ButtonComponent from '../../component/button/button.component';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { RestaurantManager } from './restaurant-manager/restaurant-manager';
import AuthGroup from './auth-group/auth-group';
import { TopBarState } from '../../component/top-bar/top-bar-state';
import GroupAccount from './group-info/group-account';
import { GroupAccountState } from './group-info/group-account-state';

export const groupUnitData = MobxObjectsManager.get(GroupUnitData);
const GroupUnit = observer(({ group, goBack }: { group: Group, goBack: () => void }) => {
    const topBarState = MobxObjectsManager.get(TopBarState);
    useEffect(() => {
        MobxObjectsManager.get(GroupUnitData, group);
    });
    useEffect(() => {
        topBarState.updateGroupTitle(group.nickname || '');
    }, [topBarState, group.nickname]);
    useManualRemove(GroupUnitData);
    const config = {
        panel: [
            { title: i18n.t('group_info_page_button_group_account') },
            { title: i18n.t('restaurant_management_page') },
            { title: i18n.t('main_page_button_manage_account') },
            { title: i18n.t('main_page_button_authorization_management') },
            { title: i18n.t('main_page_button_permission_group') },
        ]
    }
    return (
        <div className='group-management-page group-unit'>
            <Box className='FC' marginBottom={'1rem'} >
                <ButtonComponent
                    {...{
                        variant: 'contained',
                        size: 'small',
                        extraButtonStyle: 'return-button',
                        extraTitleStyle: 'return-button-icon',
                        titleText: `${i18n.t('general_button_go_back')}`,
                        // 返回集团管理列表
                        handleClick: () => { goBack(); topBarState.updateGroupTitle(''); },
                        children: <ChevronLeftIcon />
                    }}
                />
                <Tab
                    data={config.panel}
                    activeIndex={groupUnitData.panel}
                    containerStyle={{}}
                    itemStyle={{ marginLeft: 4, marginRight: 4 }}
                    onClick={(index: number) => groupUnitData.updatePanel(index)}
                />
            </Box>
            <CardView
                // 集团账号允许导航跟随页面吸顶，避免卡片裁剪创建独立滚动容器。
                style={groupUnitData.panel === 0 ? { overflow: 'visible' } : undefined}
                contentRender={<PanelFilter group={group} />}
            />
        </div>
    )
})

const PanelFilter = observer((props: { group: Group }) => {
    const { group } = props;
    // 集团账号数据管理
    const useAccountData = useLocalObservable(() => new GroupAccountState({
        belongedGroup: group.string_id,
        belongedGroupId: group._id,
        componentType: 'EDIT',
    }));
    groupUnitData.belongedReseller = useAccountData.belongedResellerId || '';
    switch (groupUnitData.panel) {
        case 0:
            return (
                <GroupAccount
                    componentType={'EDIT'}
                    useGroupAccountMobx={useAccountData}
                />
            )            // 集团账号
        case 1: return <RestaurantManager groupName={group.nickname || ''} />;       // 餐厅管理
        case 2: return <AccountManager />;          // 账号管理
        case 3: return <AuthorizationManager comType={'GROUP'} />;    // 授权管理
        case 4: return <AuthGroup enterCompType={'AU_SET'} />;               // 权限组
        default: return <></>;
    }
})

export default GroupUnit;
